import moment from "moment";

const INPUT_FORMATS = [
    "YYYY-MM-DD hh:mm A",     // 2026-07-15 09:30 AM
    "YYYY-MM-DD",             // 2026-07-15
    "DD/MM/YYYY",             // 15/07/2026
    "MM/DD/YYYY",             // 07/15/2026
    "DD/MM/YYYY hh:mm A",     // 15/07/2026 09:30 AM
    "MM/DD/YYYY hh:mm A",     // 07/15/2026 09:30 AM
    "DD MMM YYYY",            // 15 Jul 2026
    "DD MMM YYYY hh:mm A",    // 15 Jul 2026 09:30 AM
    moment.ISO_8601,          // 2026-07-15T09:30:00Z or 2026-07-15T09:30:00+05:30
    "HH:mm:ss",               // 12:55:47
    "HH:mm",                  // 12:55
    "MM-YYYY",                // 01-2026
    "MM/YYYY",                // 01/2026
];

const parseDate = (date) => {
    return moment(date, INPUT_FORMATS, true); // strict parsing
};

// Format EX: DD MMM YYYY hh:mm A 
export const formatDate = (date, format = "DD/MM/YYYY") => {
    if (!date) return "";

    const m = parseDate(date);
    if (!m.isValid()) return "";

    return m.format(format);

};

export const getDate = (date) => {
    if (!date) return "";

    const m = parseDate(date);
    if (!m.isValid()) return "";

    return m.format("DD");
};

export const getTime = (date) => {
    if (!date) return "";

    const m = parseDate(date);
    if (!m.isValid()) return "";

    return m.format("hh:mm A");
};

export const getMonth = (date) => {
    if (!date) return "";

    const m = parseDate(date);
    if (!m.isValid()) return "";

    return m.format("MMM");
};

export const formatDateInShort = (date) => {
    if (!date) return "";

    const m = parseDate(date);
    if (!m.isValid()) return "";

    return m.format("D MMM YYYY");
};

export const getCookieMaxAge = (date) => {
    if (!date) return;
    const m = parseDate(date);
    if (!m.isValid()) return;
    const now = moment();
    const diffInSeconds = m.diff(now, "seconds");
    const st = diffInSeconds > 0 ? diffInSeconds : 0;
    return st;
};

// Format "HH:mm:ss" → "hh:mm AM/PM" (for simple time strings e.g. from attendance API)
export const formatSimpleTime = (timeStr) => {
    if (!timeStr) return "-";
    const [hourStr, minuteStr] = timeStr.split(":");
    let hour = parseInt(hourStr, 10);
    if (isNaN(hour)) return "-";
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${String(hour).padStart(2, "0")}:${minuteStr} ${ampm}`;
};

// Format Unix timestamp (ms) → "hh:mm:ss A"  e.g. 1781168688000 → "09:44:48 AM"
export const formatTimestamp = (ms) => {
    if (!ms) return "-";
    return moment(ms).format("hh:mm:ss A");
};

// Format decimal hours (e.g. 8.45) → "8 hr 45 min"
export const formatWorkingHours = (hours) => {
    if (hours == null || isNaN(hours)) return "-";
    const duration = moment.duration(hours, "hours");
    const h = Math.floor(duration.asHours());
    const m = duration.minutes();
    return `${h} hr ${String(m).padStart(2, "0")} min`;
};

export const formatDateLikeGmail = (date) => {
    if (!date) return "";

    const momentDate = parseDate(date);
    if (!momentDate.isValid()) return "";

    const now = moment();

    if (momentDate.isSame(now, "day")) {
        return momentDate.format("hh:mm A");
    } else if (momentDate.isSame(now, "year")) {
        return momentDate.format("MMM D");
    } else {
        return momentDate.format("MMM D, YYYY");
    }
};

// Returns { dateRange: ["YYYY-MM-DD", "YYYY-MM-DD"] } for last N days (default 7)
export const getDefaultDateRange = (days = 7) => {
    const today = moment();
    const from = moment().subtract(days - 1, "days");
    return {
        dateRange: [
            from.format("YYYY-MM-DD"),
            today.format("YYYY-MM-DD"),
        ],
    };
};
